import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const SearchIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>search</title>
      <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="1-合约交易2" transform="translate(-26, -122)" fill="#7E8591" fill-rule="nonzero">
          <g id="编组-33" transform="translate(10, 104)">
            <g id="编组-3" transform="translate(10, 10)">
              <g id="编组" transform="translate(6, 8)">
                <path d="M8.19890457,2.02491688 C11.6161665,2.02491688 14.3864046,4.79515499 14.3864046,8.21241688 C14.3864046,9.71833479 13.8484282,11.0986016 12.9541789,12.1715139 L15.8243547,15.0423719 C16.0440246,15.2620418 16.0440246,15.6181971 15.8243547,15.837867 C15.6046848,16.0575369 15.2485295,16.0575369 15.0288596,15.837867 L12.1580016,12.9676912 C11.0850893,13.8619405 9.70482248,14.3999169 8.19890457,14.3999169 C4.78164268,14.3999169 2.01140457,11.6296788 2.01140457,8.21241688 C2.01140457,4.79515499 4.78164268,2.02491688 8.19890457,2.02491688 Z M8.19890457,3.14991688 C5.40296303,3.14991688 3.13640457,5.41647533 3.13640457,8.21241688 C3.13640457,11.0083584 5.40296303,13.2749169 8.19890457,13.2749169 C10.9948461,13.2749169 13.2614046,11.0083584 13.2614046,8.21241688 C13.2614046,5.41647533 10.9948461,3.14991688 8.19890457,3.14991688 Z" id="形状"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </span>
);

export default SearchIcon;
